import PropTypes from 'prop-types';
import { useState } from 'react';
import { ReactComponent as ArrowDownIcon } from '../../assets/images/icons/ArrowDown.svg';
import { ReactComponent as ArrowUpIcon } from '../../assets/images/icons/ArrowUp.svg';
import useTranslate from '../../hooks/useTranslate/useTranslate';
import styles from './Policies.module.css';

export const Policy = ({ title, type, description, collapsible = true }) => {
  const { t } = useTranslate();
  const [policyDescriptionOpen, setPolicyDescriptionOpen] = useState(false);

  return (
    <div className={styles.policy}>
      <button
        type="button"
        onClick={
          collapsible
            ? () => setPolicyDescriptionOpen(!policyDescriptionOpen)
            : undefined
        }
        className={styles.policyButton}
        style={!collapsible ? { cursor: 'default' } : {}}
      >
        <h6>{title}</h6>
        {collapsible && (
          <div className={styles.arrowIcon}>
            {policyDescriptionOpen ? (
              <ArrowUpIcon style={{ marginLeft: 8 }} />
            ) : (
              <ArrowDownIcon style={{ marginLeft: 8 }} />
            )}
          </div>
        )}
      </button>
      {(collapsible ? policyDescriptionOpen : true) &&
        description.map(({ description }, i) => (
          <div>
            <span key={`${type}-policy-${i}`}>{description}</span>
            {type === 'cancellationPolicy' && (
              <div>
                {t(
                  'In the event of a no-show or early departure, the full value of the booking will be charged'
                )}
              </div>
            )}
          </div>
        ))}
    </div>
  );
};

Policy.propTypes = {
  title: PropTypes.string,
  type: PropTypes.string,
  description: PropTypes.array,
  collapsible: PropTypes.bool,
};
